// Granite Peak Manufacturing - Setups page logic (job setups + machine setups, localStorage)
(function (global) {
'use strict';
var GPM = global.GPM;

var editingJobId = null;
var editingMachineId = null;

function esc(s) { return GPM.esc(s); }
var calcUrl = (typeof global.GPM_CALC_URL === 'string' && global.GPM_CALC_URL) || 'calculator.html';

/* ── Job setups ── */
function renderJobs() {
  var jobs = GPM.getJobSetups();
  var wrap = document.getElementById('gpm-jobs-grid');
  if (!jobs.length) {
    wrap.innerHTML = '<div class="gpm-empty" style="grid-column:1/-1;">No job setups yet. Create one to plan your next part.</div>';
    return;
  }
  wrap.innerHTML = jobs.map(function (j) {
    var badge = j.status === 'ready' ? 'badge-ready' : j.status === 'completed' ? 'badge-completed' : 'badge-draft';
    var params = new URLSearchParams();
    if (j.material) params.set('material', j.material);
    if (j.tool) params.set('tool', j.tool);
    if (j.notes) params.set('notes', j.notes);
    return '<div class="shop-panel gpm-setup-card">'
      + '<div class="card-top"><h4>' + esc(j.job_name) + '</h4><span class="gpm-badge ' + badge + '">' + esc(j.status || 'draft') + '</span></div>'
      + (j.material ? '<div class="meta">Material: <b>' + esc(j.material) + '</b></div>' : '')
      + (j.tool ? '<div class="meta">Tool: <b>' + esc(j.tool) + '</b></div>' : '')
      + (j.notes ? '<div class="notes">' + esc(j.notes) + '</div>' : '')
      + '<div class="card-actions">'
      + '<a class="gpm-btn gpm-btn-primary gpm-btn-sm" href="' + calcUrl + '?' + params.toString() + '">Load in Calculator</a>'
      + '<button class="gpm-btn gpm-btn-outline gpm-btn-sm" data-edit-job="' + esc(j.id) + '">Edit</button>'
      + '<button class="gpm-btn gpm-btn-outline gpm-btn-sm" data-del-job="' + esc(j.id) + '">Delete</button>'
      + '</div></div>';
  }).join('');

  wrap.querySelectorAll('[data-del-job]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      GPM.saveJobSetups(GPM.getJobSetups().filter(function (j) { return String(j.id) !== btn.getAttribute('data-del-job'); }));
      renderJobs();
    });
  });
  wrap.querySelectorAll('[data-edit-job]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var job = GPM.getJobSetups().find(function (j) { return String(j.id) === btn.getAttribute('data-edit-job'); });
      if (!job) return;
      editingJobId = job.id;
      var f = document.getElementById('gpm-job-form');
      f.elements['job-name'].value = job.job_name || '';
      f.elements['job-material'].value = job.material || '';
      f.elements['job-tool'].value = job.tool || '';
      f.elements['job-status'].value = job.status || 'draft';
      f.elements['job-notes'].value = job.notes || '';
      document.getElementById('gpm-job-form-title').textContent = 'Edit Setup';
      document.getElementById('gpm-job-form-wrap').style.display = '';
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

/* ── Machine setups ── */
function renderMachines() {
  var machines = GPM.getMachineSetups();
  var activeId = GPM.getActiveMachineId();
  if (!activeId || !machines.some(function (m) { return m.id === activeId; })) {
    activeId = machines[0] ? machines[0].id : '';
    GPM.setActiveMachineId(activeId);
  }
  var wrap = document.getElementById('gpm-machines-grid');
  if (!machines.length) {
    wrap.innerHTML = '<div class="gpm-empty" style="grid-column:1/-1;">No machines yet. Add your machine limits to drive the calculator.</div>';
    return;
  }
  wrap.innerHTML = machines.map(function (m) {
    var isActive = m.id === activeId;
    return '<div class="shop-panel gpm-setup-card"' + (isActive ? ' style="border-color:var(--shop-amber);"' : '') + '>'
      + '<div class="card-top"><h4>' + esc(m.name) + '</h4>' + (isActive ? '<span class="gpm-active-chip">Active</span>' : '') + '</div>'
      + '<div class="meta">Max RPM: <b>' + esc(m.maxRpm || '—') + '</b> &nbsp; Max Feed: <b>' + esc(m.maxIpm || m.maxFeedrate || '—') + '</b></div>'
      + '<div class="meta">Spindle: <b>' + esc(m.spindlePower || '—') + ' HP</b> &nbsp; Peak Torque: <b>' + esc(m.peakTorque || '—') + ' lb-in</b></div>'
      + '<div class="meta">Torque Transition: <b>' + esc(m.torqueTransitionRpm || '—') + ' rpm</b></div>'
      + '<div class="card-actions">'
      + (isActive ? '' : '<button class="gpm-btn gpm-btn-primary gpm-btn-sm" data-activate-machine="' + esc(m.id) + '">Set Active</button>')
      + '<button class="gpm-btn gpm-btn-outline gpm-btn-sm" data-edit-machine="' + esc(m.id) + '">Edit</button>'
      + '<button class="gpm-btn gpm-btn-outline gpm-btn-sm" data-del-machine="' + esc(m.id) + '">Delete</button>'
      + '</div></div>';
  }).join('');

  wrap.querySelectorAll('[data-activate-machine]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      GPM.setActiveMachineId(btn.getAttribute('data-activate-machine'));
      renderMachines();
    });
  });
  wrap.querySelectorAll('[data-del-machine]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      GPM.saveMachineSetups(GPM.getMachineSetups().filter(function (m) { return String(m.id) !== btn.getAttribute('data-del-machine'); }));
      renderMachines();
    });
  });
  wrap.querySelectorAll('[data-edit-machine]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var m = GPM.getMachineSetups().find(function (x) { return String(x.id) === btn.getAttribute('data-edit-machine'); });
      if (!m) return;
      editingMachineId = m.id;
      var f = document.getElementById('gpm-machine-form');
      f.elements['machine-name'].value = m.name || '';
      f.elements['machine-rpm'].value = m.maxRpm || '';
      f.elements['machine-feed'].value = m.maxFeedrate || m.maxIpm || '';
      f.elements['machine-hp'].value = m.spindlePower || '';
      f.elements['machine-torque'].value = m.peakTorque || '';
      f.elements['machine-transition'].value = m.torqueTransitionRpm || '';
      document.getElementById('gpm-machine-form-title').textContent = 'Edit Machine Setup';
      document.getElementById('gpm-machine-form-wrap').style.display = '';
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  /* job form */
  document.getElementById('gpm-new-job-btn').addEventListener('click', function () {
    editingJobId = null;
    document.getElementById('gpm-job-form').reset();
    document.getElementById('gpm-job-form-title').textContent = 'New Setup';
    var w = document.getElementById('gpm-job-form-wrap');
    w.style.display = w.style.display === 'none' ? '' : 'none';
  });
  document.getElementById('gpm-job-cancel').addEventListener('click', function () {
    document.getElementById('gpm-job-form-wrap').style.display = 'none';
    editingJobId = null;
  });
  document.getElementById('gpm-job-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target;
    var data = {
      job_name: f.elements['job-name'].value.trim(),
      material: f.elements['job-material'].value.trim(),
      tool: f.elements['job-tool'].value.trim(),
      status: f.elements['job-status'].value,
      notes: f.elements['job-notes'].value.trim()
    };
    if (!data.job_name) return;
    var jobs = GPM.getJobSetups();
    if (editingJobId) {
      jobs = jobs.map(function (j) { return String(j.id) === String(editingJobId) ? Object.assign({}, j, data, { updated_date: new Date().toISOString() }) : j; });
    } else {
      jobs = [Object.assign({ id: GPM.nextId('setup'), created_date: new Date().toISOString() }, data)].concat(jobs);
    }
    GPM.saveJobSetups(jobs);
    f.reset();
    editingJobId = null;
    document.getElementById('gpm-job-form-wrap').style.display = 'none';
    renderJobs();
  });

  /* machine form */
  document.getElementById('gpm-new-machine-btn').addEventListener('click', function () {
    editingMachineId = null;
    document.getElementById('gpm-machine-form').reset();
    document.getElementById('gpm-machine-form-title').textContent = 'New Machine Setup';
    var w = document.getElementById('gpm-machine-form-wrap');
    w.style.display = w.style.display === 'none' ? '' : 'none';
  });
  document.getElementById('gpm-machine-cancel').addEventListener('click', function () {
    document.getElementById('gpm-machine-form-wrap').style.display = 'none';
    editingMachineId = null;
  });
  document.getElementById('gpm-machine-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target;
    var data = {
      name: f.elements['machine-name'].value.trim(),
      maxRpm: f.elements['machine-rpm'].value.trim(),
      maxFeedrate: f.elements['machine-feed'].value.trim(),
      maxIpm: f.elements['machine-feed'].value.trim(),
      spindlePower: f.elements['machine-hp'].value.trim(),
      peakTorque: f.elements['machine-torque'].value.trim(),
      torqueTransitionRpm: f.elements['machine-transition'].value.trim()
    };
    if (!data.name) { document.getElementById('gpm-machine-error').textContent = 'Machine name is required.'; return; }
    document.getElementById('gpm-machine-error').textContent = '';
    var machines = GPM.getMachineSetups();
    if (editingMachineId) {
      machines = machines.map(function (m) { return String(m.id) === String(editingMachineId) ? Object.assign({}, m, data) : m; });
    } else {
      var newMachine = Object.assign({ id: GPM.nextId('machine'), createdAt: new Date().toISOString() }, data);
      machines = [newMachine].concat(machines);
      GPM.setActiveMachineId(newMachine.id);
    }
    GPM.saveMachineSetups(machines);
    f.reset();
    editingMachineId = null;
    document.getElementById('gpm-machine-form-wrap').style.display = 'none';
    renderMachines();
  });

  renderJobs();
  renderMachines();
});
})(window);
